export const connectCast = (channel) =>{
    return(dispatch,getState)=>{
       
        if(!getState().cast.session){
            window.cast.framework.CastContext.getInstance().setOptions({
                receiverApplicationId:'F3AC4145'
              });
           
            window.cast.framework.CastContext.getInstance().requestSession().then((sucess)=>{
                var castSession = window.cast.framework.CastContext.getInstance().getCurrentSession();
                dispatch(setCastSession(castSession));
                dispatch(playCast(channel));
            });
        }else{
            dispatch(playCast(channel));
        }
    }
}

export const setCastSession = (session) =>{
    return{
        type:"SET_CAST_SESSION",
        payload:session
    }
}

export const setCastPlaying = (castIsPlaing)=>{
    return {
        type:'SET_CAST_PLAYINT',
        payload:castIsPlaing
    }
}

export const playCast = (channel)=>{
   return (dispatch,getState)=>{
    let url;
    url = channel.url;
    


    let player = new window.cast.framework.RemotePlayer()
    let playerController = new window.cast.framework.RemotePlayerController(player)
    let mediaInfo = new window.chrome.cast.media.MediaInfo(url, 'application/x-mpegURL')
    mediaInfo.metadata = new window.chrome.cast.media.GenericMediaMetadata();

    const image = new window.chrome.cast.Image(channel.logo_url)
    image.width = 200;
    image.height= 200;

    mediaInfo.metadata.images = [image]
    mediaInfo.metadata.title = channel.name
    mediaInfo.customData = null;
    mediaInfo.streamType = window.chrome.cast.media.StreamType.BUFFERED;
    mediaInfo.textTrackStyle = new window.chrome.cast.media.TextTrackStyle();
    mediaInfo.duration = null;

    let request = new window.chrome.cast.media.LoadRequest(mediaInfo)
    window.cast.framework.CastContext.getInstance().getCurrentSession().loadMedia(request).then(()=>{
      dispatch(setCastPlaying(true));
    },(err)=>{
      console.log(err);
    });
   }
}


// WEBPACK FOOTER //
// ./src/actions/cast.js